var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.5H16V9.5314C16 5.64806 12.866 2.5 9 2.5C5.13401 2.5 2 5.64806 2 9.5314V16.5ZM9 0.5C13.9706 0.5 18 4.54348 18 9.5314V18.5H0V9.5314C0 4.54348 4.02944 0.5 9 0.5ZM6.5 19.5H11.5C11.5 20.8807 10.3807 22 9 22C7.6193 22 6.5 20.8807 6.5 19.5Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/Notification-Icon.62178f4b135241d903010987ce98d4cf.svg";
export { ForwardRef as ReactComponent };